import axios from "axios";
import { primeSpeech, stopVoice } from "@/lib/voice";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const unlockAudio = () => primeSpeech();

export const createSession = () => axios.post(`${API}/sessions`, null, { timeout: 30000 }).then((r) => r.data);

export const sendMessage = (sessionId, text) =>
  axios.post(`${API}/sessions/${sessionId}/message`, { text }, { timeout: 25000 }).then((r) => r.data);

export const audioUrl = (sessionId, messageId) =>
  `${API}/sessions/${sessionId}/messages/${messageId}/audio`;


export const voiceTestUrl = `${API}/voice/test`;

export const stopAudio = () => stopVoice();

export const getConfig = () => axios.get(`${API}/config`, { timeout: 8000 }).then((r) => r.data);

export const startSession = (sid) => axios.post(`${API}/sessions/${sid}/start`).then((r) => r.data);
export const getSession = (sid) => axios.get(`${API}/sessions/${sid}`).then((r) => r.data);
export const resumeSession = (sid) => axios.post(`${API}/sessions/${sid}/resume`).then((r) => r.data);
export const endSession = (sid, finalSource, timeout) =>
  axios.post(`${API}/sessions/${sid}/end`, { final_source: finalSource }, { timeout }).then((r) => r.data);

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const createSessionWithRetry = async () => {
  for (;;) {
    try {
      return await createSession();
    } catch (e) {
      await sleep(2000);
    }
  }
};

const KEY = "spore_session_id";
export const storedSessionId = () => localStorage.getItem(KEY);
export const storeSessionId = (id) => localStorage.setItem(KEY, id);
export const clearSessionId = () => localStorage.removeItem(KEY);

export const abandonSession = (sid) =>
  fetch(`${API}/sessions/${sid}/abandon`, { method: "POST", keepalive: true }).catch(() => null);
